import {
  Box, Dialog, DialogActions, DialogContent,
  DialogTitle,
  IconButton, Typography,
  Button,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import { POSITION_STATE } from '../../../consts/enums';
import STRING_KEYS from '../../../language/keys';
import { PositionState } from '../../../@types/position';
import { style } from './style';

type PositionReopenDialogProps = {
  onCloseDialog: () => void,
  onPositionStateChange: (positionState: PositionState) => void,
  isOpen: boolean,
}

export const PositionReopenDialog = ({
  onCloseDialog,
  isOpen,
  onPositionStateChange,
}: PositionReopenDialogProps): JSX.Element => {
  const { t: translate } = useTranslation();

  const handleReopenPosition = () => {
    onPositionStateChange({
      state: POSITION_STATE.OPEN,
    });
  };

  return (
    <Dialog
      open={ isOpen }
      fullWidth
      onClick={ (e) => e.stopPropagation() }
    >
      <DialogTitle sx={ style.dialogTitle }>
        <Box sx={ style.titleBox }>
          <Typography variant={ style.titleVariant }>
            {translate(STRING_KEYS.REOPEN_POSITION_DIALOG_TITLE)}
          </Typography>
          <IconButton
            onClick={ onCloseDialog }
            sx={ style.closeIcon }
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography>
          {translate(STRING_KEYS.REOPEN_POSITION_DIALOG_SUBTITLE)}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="text" color="primary" onClick={ onCloseDialog }>
          {translate(STRING_KEYS.DIALOG.BTN_GO_BACK)}
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={ handleReopenPosition }
        >
          {translate(STRING_KEYS.REOPEN_POSITION_DIALOG_CONFIRM)}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
